import React from 'react';
import { Helmet } from 'react-helmet-async';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { motion } from 'framer-motion';

const NotFound = () => {
  return (
    <>
      <Helmet>
        <title>Page Not Found | Redemption Psychiatry</title>
      </Helmet>
      <div className="wrap">
        <Header />
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.8 }}
        >
          <div id="content" role="main" className="home">
            {/* Interior Header */}
            <div id="interior-header-container" className="container-fluid">
              <div className="container">
                <h1>404 - Page Not Found</h1>
              </div>
            </div>

            {/* 404 Content */}
            <div className="container" style={{ padding: '80px 0', textAlign: 'center' }}>
              <h2>Oops! We Can't Find That Page</h2>
              <p className="large">
                The page you're looking for might have been moved, deleted, or doesn't exist. 
                But don't worry – we're here to help you find what you need.
              </p>
              
              <div style={{ margin: '40px 0' }}>
                <a href="/" className="button blue" style={{ marginRight: '20px' }}>
                  Return Home
                </a>
                <a href="/contact" className="button blue-border">
                  Contact Us
                </a>
              </div>

              <div style={{ marginTop: '60px' }}>
                <h3>Popular Pages</h3>
                <div style={{ 
                  display: 'flex', 
                  flexWrap: 'wrap', 
                  justifyContent: 'center', 
                  gap: '20px',
                  marginTop: '20px'
                }}>
                  <a href="/services" style={{ color: '#007bff', textDecoration: 'underline' }}>Our Services</a>
                  <a href="/about" style={{ color: '#007bff', textDecoration: 'underline' }}>About Us</a>
                  <a href="/provider-biographies" style={{ color: '#007bff', textDecoration: 'underline' }}>Our Team</a>
                  <a href="/resources" style={{ color: '#007bff', textDecoration: 'underline' }}>Resources</a>
                  <a href="/newpatients" style={{ color: '#007bff', textDecoration: 'underline' }}>New Patients</a>
                </div>
              </div>
            </div>
          </div>
          <div className="push"></div>
        </motion.div>

        {/* Footer */}
        <Footer />
      </div>
    </>
  );
};

export default NotFound;